import { RouteParamsType } from '../../types/utils/router-params.type';

export const initialLocationTicketsTabRouteParams: RouteParamsType = {
  page: 1,
  limit: 10,
  order: '-tickets.id',
  q: '',
  priority: '',
  status: '',
  action: '',
  department: '',
  start_date: '',
  end_date: '',
  org_type: '',
  tech_on_site: '',
};

export const initialLocationOrdersTabRouteParams: RouteParamsType = {
  page: 1,
  limit: 10,
  order: '-obj.createdAt',
  q: '',
  status: '',
  carrier_name: '',
  reseller_id: '',
  customer_id: '',
  warehouse_id: '',
  is_telcobill_order: '',
};

export const initialLocationServiceCallsTabRouteParams: RouteParamsType = {
  page: 1,
  limit: 25,
  order: '-id',
  q: '',
  status: '',
  serviceVariant: '',
};
